import {
  createAppPublicPathHelpers,
  readAppPublicPathFromEnv,
} from "@airange/shared/app-public-path";

function configuredPublicPath() {
  return typeof __AIRANGE_APP_PUBLIC_PATH__ === "string"
    ? __AIRANGE_APP_PUBLIC_PATH__
    : readAppPublicPathFromEnv();
}

function helpers(publicPath: string | null | undefined = configuredPublicPath()) {
  return createAppPublicPathHelpers(publicPath);
}

export const browserBaseName = helpers().browserBaseName;
export const getBrowserBaseName = () => helpers().browserBaseName;
export const isAppLocalPathname = (browserPathname: string, appLocalPathname: string) =>
  helpers().isAppLocalPathname(browserPathname, appLocalPathname);
export const toAppLocalPathname = (browserPathname: string) => helpers().toAppLocalPathname(browserPathname);
export const toAppLocalUrlPath = (browserUrlPath: string) => helpers().toAppLocalUrlPath(browserUrlPath);
export const normalizeAppLocalUrlPath = (appLocalUrlPath: string, appPublicPath?: string | null) =>
  helpers(appPublicPath).normalizeAppLocalUrlPath(appLocalUrlPath);
export const toBrowserPath = (appLocalUrlPath: string) => helpers().toBrowserPath(appLocalUrlPath);
